<template>
  <div class="calculator-sidebar">
    <div class="logo"></div>

    <div class="step"
         v-for="(group, index) in groups"
         :class="{'completed':  index < activeStep, 'active': index === activeStep}">
      <div class="step-icon">
        {{ index + 1 }}
      </div>
      <div class="step-label">
        {{ group.label }}
      </div>

    </div>
    <div class="side-tip"
         v-for="(group, index) in groups"
         v-if="index === activeStep"
    >
      <div class="side-tip-title">
        Tips for best results
      </div>
      <div class="side-tip-content" v-html="group.desc">
      </div>
    </div>

  </div>
</template>

<script>
import {mapState} from "vuex";
import store from "../store";

export default {
  store,
  props: ['activeStep'],
  data() {
    return {
      completedSteps: {},
    }
  },
  computed: {
    ...mapState(['groups'])
  }
}
</script>

<style scoped lang="scss">
@import "../../../style/mixins";

.logo {
  background-position: 17px 0px;
  background-size: 150px;
  background-repeat: no-repeat;
  background-image: url(../../../images/logo.svg);
  height: 40px;
  margin-top: calculateRem(32px);
  margin-bottom: calculateRem(32px);
}

.calculator-sidebar {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 256px;
  background-color: #E9EAEC;
}

.step {
  /*cursor: pointer;*/
  padding: 0 0 0 64px;
  position: relative;
  line-height: 40px;
  font-size: 18px;
  margin-bottom: 16px;

  .step-icon {
    height: 24px;
    width: 24px;
    font-family: "Lota Grotesque Regular", sans-serif;
    position: absolute;
    top: 7px;
    left: 18px;
    text-align: center;
    line-height: 24px;
    background-color: #ccc;
    border-radius: 50%;
    font-size: 14px;
  }

  .step-label {
    color: #7C828A;
  }

  &.active {
    background: #D3D5D8;

    .step-icon {
      color: #fff;
      background-color: #1EBCBE;
    }
  }

  &.completed {
    .step-icon {
      color: #fff;
      background-color: #1EBCBE;
    }
  }
}

.side-tip {
  margin-top: 64px;
  border-top: 1px solid #D3D5D8;
  padding: 24px;

  .side-tip-title {
    font-weight: bold;
    margin-bottom: 24px;
  }
}

</style>
